import { useHotkeys } from 'react-hotkeys-hook';

import { useSearchStore } from '@/stores/search';

export const SearchHotkeySetup = () => {
  const { updateStore } = useSearchStore();

  const toggleSearch = () =>
    updateStore({
      type: 'TOGGLE_SEARCH',
    });

  useHotkeys(
    'mod+k',
    () => {
      toggleSearch();
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
    },
  );

  return null;
};
